export default __webpack_public_path__ + "static/media/map-01.b2561077.png";